import ResponsiveField from '@admin/components/mjson_designer/components/responsivefield'
import SegmentsField from '@admin/components/mjson_designer/components/segmentsfield'
import LayoutField from '@admin/components/mjson_designer/components/layoutfield'
import WebRange from '@admin/components/mjson_designer/components/webrange'
import { normalizeConfig } from '../../../utils'
import Form from '@admin/components/form'
import * as styles from '../styles'
import settings from '../settings'
import PropTypes from 'prop-types'
import React from 'react'

const Range = (props) => <ResponsiveField { ...props } component={ WebRange } />

class Row extends React.PureComponent {

  static contextTypes = {
    form: PropTypes.object
  }

  static propTypes = {
    device: PropTypes.string,
    entity: PropTypes.object,
    theme: PropTypes.object,
    type: PropTypes.string,
    onChange: PropTypes.func,
    onDone: PropTypes.func
  }

  formRef = React.createRef()

  _handleCancel = this._handleCancel.bind(this)
  _handleDone = this._handleDone.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleUpdate = this._handleUpdate.bind(this)

  constructor(props) {
    super(props)
    const { entity } = props
    this.state = {
      default: entity,
      config: entity
    }
  }

  render() {
    return <Form { ...this._getForm() } />
  }

  componentDidUpdate(prevProps, prevState) {
    const { config } = this.state
    if(!_.isEqual(config, prevState.config)) {
      this._handleChange()
    }
  }

  _getForm() {
    const { device, entity, theme, type } = this.props
    const { config } = this.state
    return {
      ref: this.formRef,
      onChange: this._handleUpdate,
      onSuccess: this._handleDone,
      showHeader: false,
      buttons: [
        { label: 't(Cancel)', color: 'blue', basic: true, handler: this._handleCancel },
        { label: 't(Done)', color: 'blue', handler: this._handleSubmit }
      ],
      tabs: [
        {
          label: 't(Content)',
          sections: [
            {
              fields: [
                { label: 't(Columns)', name: 'content.children', type: SegmentsField, entity: 'email_column', theme, value: config.content.children },
                { label: 't(Column Layout)', type: 'segment', fields: [
                  { name: 'content.layout', type: LayoutField, theme, value: config.content.layout },
                  { name: 'content.break_columns', type: 'checkboxgroup', options: [
                    { value: 'tablet', text: 't(Break Columns For Tablet)' },
                    { value: 'mobile', text: 't(Break Columns For Mobile)' }
                  ], defaultValue: ['tablet','mobile'], value: config.content.break_columns }
                ] }
              ]
            }
          ]
        },
        {
          label: 't(Styles)',
          sections: [
            {
              label: 't(Row)',
              instructions: 't(Specify how this row should appear within its parent)',
              collapsing: true,
              collapsed: true,
              fields: [
                { label: 't(Row Width)', name: 'styles.rowWidth', device, type: Range, units: [
                  { name: 'px', min: 0, max: 1200, step: 1 }
                ], nullValues: ['auto'], defaultValue: 'auto', value: config.styles.rowWidth }
              ]
            },
            styles.BackgroundSection(config, device, theme, null, type),
            styles.BorderSection(config, device, theme, null, type),
            styles.SpacingSection(config, device, theme, null, type),
            styles.VisibilitySection(config, device, theme, null, type)
          ]
        },
        {
          label: 't(Settings)',
          sections: settings(config, type, entity)
        }
      ]
    }
  }

  _getNormalized() {
    const { entity } = this.props
    const { config } = this.state
    return normalizeConfig({
      ...entity,
      meta: config.meta,
      settings: config.settings,
      styles: config.styles,
      content: config.content
    })
  }

  _handleCancel() {
    this.props.onDone(this.state.default)
  }

  _handleChange() {
    const config = this._getNormalized()
    this.props.onChange(config)
  }

  _handleDone() {
    const config = this._getNormalized()
    this.props.onDone(config)
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleUpdate(config) {
    this.setState({
      config: {
        ...this.state.config,
        ...config
      }
    })
  }

}

export default Row
